import { render, staticRenderFns } from "./vampire.vue?vue&type=template&id=3e9c5970"
import script from "./vampire.vue?vue&type=script&lang=js"
export * from "./vampire.vue?vue&type=script&lang=js"
import style0 from "./vampire.vue?vue&type=style&index=0&id=3e9c5970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports